import { __read as t } from "../_virtual/_tslib.js";
import { createContext as e, useState as o, useEffect as r } from "react";
import n from "../useAmap.js";
var i = e(void 0);

function f(e, i) {
  var f = e.init,
      u = e.destroy,
      a = void 0 === u ? function (t) {
    "function" == typeof t.destroy && t.destroy();
  } : u,
      c = e.add,
      p = void 0 === c ? function (t, e) {
    "function" == typeof e.setMap && e.setMap(t);
  } : c,
      s = e.remove,
      d = void 0 === s ? function (t, e) {
    "function" == typeof e.setMap && e.setMap(null);
  } : s,
      v = e.prepare,
      m = void 0 === v ? function () {
    return Promise.resolve();
  } : v,
      y = n(),
      l = t(o(!1), 2),
      M = l[0],
      b = l[1],
      j = t(o(), 2),
      x = j[0],
      A = j[1];
  return r(function () {
    m().then(function () {
      return b(!0);
    });
  }, []), r(function () {
    if (M && y) {
      var t = i.lifeCycle,
          e = f(AMap, y);
      return p(y, e), A(e), t && t.created && t.created(e), function () {
        d(y, e), t && t.beforeDestroy && t.beforeDestroy(e), a(e);
      };
    }
  }, [M, y]), x;
}

export default f;
export { i as LifeCycleContext };